module.exports = __webpack_public_path__ + "images/emoji/beers.0225045e6458f3ae7ddc.png";